import { html, TemplateResult } from "lit-html";
import { ButtonComponent } from "@components/common";
import MySearchTemplate from "./mySearch";

const MySearchesTemplate = async (
  config: ProposalConfigs,
  model: IProposalModel): Promise<TemplateResult> => {
  const {
    messages: {
      MySearchesDIVButtonNo,
      MySearchesDIVButtonAdd
    }
  } = config;
  const {
    formData,
    handleMySearchesSubmit,
    handleOneSearchSubmit
  } = model;

  return html`
    <div class="modal-body my-searches">
      <form
        class="my-searches-form"
        name="forms.my-searches"
        @submit=${handleMySearchesSubmit}
        novalidate
      >
        ${await MySearchTemplate(config, { what: formData.what.value, where: formData.where.value }, 0)}
        ${await MySearchTemplate(config, undefined, 1)}
        ${await MySearchTemplate(config, undefined, 2)}
        <div class="my-searches-form__button-container">
          <a class="jr-button jr-button-material jr-button-material--textual" @click=${handleOneSearchSubmit}>${MySearchesDIVButtonNo}</a>
          ${ButtonComponent({ type: 'submit', cssClasses: 'jr-button jr-button-material', btnText: MySearchesDIVButtonAdd })}
        </div>
      </form>
    </div>`;
}

export default MySearchesTemplate;